module.exports = __webpack_public_path__ + "static/media/toyota-phone.6de776a5.svg";